var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.425 0C9.99621 0 0 10.0712 0 22.5C0 34.9289 10.0712 45 22.5 45C34.9289 45 45 34.9289 45 22.5C45 10.0712 34.8539 0 22.425 0ZM10.7458 15.8018C10.7458 13.4714 12.6332 11.5771 14.9705 11.5771C17.3009 11.5771 19.1951 13.4645 19.1951 15.8018C19.1951 18.1322 17.3077 20.0266 14.9705 20.0266C12.6401 20.0197 10.7458 18.1322 10.7458 15.8018ZM22.6295 37.014C16.8171 37.014 12.0881 32.285 12.0881 26.4726C12.0881 25.5322 12.8513 24.7691 13.7916 24.7691H31.4741C32.4145 24.7691 33.1776 25.5322 33.1776 26.4726C33.1708 32.285 28.4418 37.014 22.6295 37.014ZM30.0023 20.0197C27.6719 20.0197 25.7776 18.1322 25.7776 15.795C25.7776 13.4645 27.6651 11.5703 30.0023 11.5703C32.3327 11.5703 34.227 13.4577 34.227 15.795C34.2201 18.1322 32.3327 20.0197 30.0023 20.0197Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.bc801b2cb67cc1c90920ae94bdd968ef.svg";
export { ForwardRef as ReactComponent };